module.exports = __webpack_public_path__ + "static/media/11.9183a67a.jpg";